import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { COLORS, ICONS, unit } from '@hcr/ui'

import type { Route } from '../../../models/navigation'
import { to } from '../../../utils'
import { Drawer } from '../drawer'
import type { DrawerProps } from '../drawer'

type DrawerNavigationBackProps = DrawerProps & { path: Route }

export const DrawerNavigationBack: FC<DrawerNavigationBackProps> = ({ path, children, ...props }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <Drawer {...props}>
      <Box
        display='flex'
        justifyContent='end'
        alignItems='center'
        position='sticky'
        top={0}
        zIndex={1}
        bgcolor={COLORS.white}
      >
        <Button
          sx={{
            padding: unit(3),
            marginTop: unit(5),
            marginRight: unit(3),
            marginBottom: unit(2),
            marginLeft: unit(2.75),
            width: unit(11),
            minWidth: 'unset',
            '&:hover': {
              backgroundColor: 'inherit',
              boxShadow: 'none',
            },
          }}
          onClick={() => navigate(to(path), { preventScrollReset: true })}
          aria-label={t('navigation.close-menu')}
        >
          <FontAwesomeIcon size={'xl'} icon={ICONS.farXmark} color={COLORS.black} aria-hidden={true} />
        </Button>
      </Box>
      {children}
    </Drawer>
  )
}
